import FirstGridItem from './FirstGridItem';
export default FirstGridItem;